export const USER_STORAGE_KEY = 'user'
export const USER_PERMISSIONS_STORAGE_KEY = 'permissions'
export const USER_TOKEN_STORAGE_KEY = 'token'
export const USER_NAME_STORAGE_KEY = 'username'
